module.exports = __webpack_public_path__ + "img/ssyx_38.76d60195.jpg";